import { Link } from '@framework/router/Next/Link';
import Button from '@creditflowresearch/uilib/Button';
import Flex from '@creditflowresearch/uilib/Flex';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import UpgradePlanButton from '@/creditflowresearch/ui/common/components/UpgradePlanButton';
import useLoginUrl from '@/creditflowresearch/ui/common/components/atoms/LoginButton/useLoginUrl';

import styles from './askAiTooltip.module.scss';

const AskAiNoAccessTooltip = () => {
  const { checkAccessByUserPlan } = useUserPlanContext();
  const loginUrl = useLoginUrl();
  const isLoggedIn = checkAccessByUserPlan(UserPlanType.STARTER);

  return (
    <Flex
      direction="column"
      align="flex-end"
      gap={ 10 }
      className={ styles.noAccessContainer }
      dataTest="askAiNoAccessTooltip"
    >
      <p className={ styles.noAccessDescription }>
        { isLoggedIn
          ? 'Upgrade your Plan to get access to CFR AI.'
          : 'Log In and Upgrade Plan plan to get access to CFR AI.' }
      </p>
      { isLoggedIn ? (
        <UpgradePlanButton dataTest="askAiTooltipUpgradePlanButton" />
      ) : (
        <Button
          as={ Link }
          to={ loginUrl }
          variant="solid"
          size="S"
          className={ styles.loginButton }
          dataTest="askAiTooltipLoginButton"
        >
          Log In
        </Button>
      ) }
    </Flex>
  );
};

export default AskAiNoAccessTooltip;
